const untranslatable = value =>
  global.GEODISC_I18N_DEBUG_ENABLED ? `🗎${String(value)}` : String(value);

export default untranslatable;
